import { Injectable } from '@angular/core';
import { HttpRequestService } from '../../shared/services/http-request.service';
import 'rxjs/add/operator/map';
import { environment } from '../../../environments/environment';
import { VenueDetailsModel } from './venue-details.model';

@Injectable()
export class VenueDetailsService {
  private getVenueURL = environment.apiUrl + '/VenueCms/GetVenueDetails';
  private getVenueDetailsEnumsUrl = environment.apiUrl + '/VenueCms/GetVenueDetailsEnums';
  private getGroupVenueListUrl = environment.apiUrl + '/VenueCms/GetGroupVenueList';
  private updateVenue = environment.apiUrl + '/VenueCms/UpdateVenue';
  private newVenue = environment.apiUrl + '/VenueCms/NewVenue';
  private deleteVenue = environment.apiUrl + '/VenueCms/DeleteVenue';
  private getGroupContactsUrl = environment.apiUrl + '/VenueCms/GetGroupContacts';
  private getVenueOrders = environment.apiUrl + '/VenueCms/GetVenueOrder';
  private getVenueAnalytiscUrl = environment.apiUrl + '/VenueCms/GetVenueAnalytisc';
  private getSubAreaListUrl = environment.apiUrl + '/SubAreaCms/List';
  private saveNewSubAreaUrl = environment.apiUrl + '/SubAreaCms/AddOrUpdate';
  private getCuisinesListUrl = environment.apiUrl + '/CuisineCms/GetCuisines';
  private saveNewCuisineUrl = environment.apiUrl + '/CuisineCms/AddOrUpdate';
  private deleteCuisineUrl = environment.apiUrl + '/CuisineCms/Delete';
  private deleteCuisinesUrl = environment.apiUrl + '/CuisineCms/DeleteMany';
  private getVibesListUrl = environment.apiUrl + '/VibeCms/GetVibes';
  private saveNewVibeUrl = environment.apiUrl + '/VibeCms/AddOrUpdate';
  private deleteVibesUrl = environment.apiUrl + '/VibeCms/DeleteMany';
  private deleteSubAreasUrl = environment.apiUrl + '/SubAreaCms/DeleteMany';

  constructor(private _http: HttpRequestService) {
  }

  getVenueDetails(id: number) {
    return this._http.get(this.getVenueURL + '?id=' + id);
  }

  getVenueDetailsEnums() {
    return this._http.get(this.getVenueDetailsEnumsUrl);
  }

  getSubAreasList() {
    return this._http.get(this.getSubAreaListUrl);
  }

  getCuisineList() {
    return this._http.get(this.getCuisinesListUrl);
  }

  addSubArea(locationFilter: number, title: any) {
    return this._http.postMultipart(this.saveNewSubAreaUrl, { locationFilter, title }, [], false);
  }

  addCuisine(title: any) {
    return this._http.postMultipart(this.saveNewCuisineUrl, { title }, [], false);
  }

  deleteCuisine(id: number) {
    return this._http.get(this.deleteCuisineUrl + '?id=' + id);
  }

  deleteCuisines(ids: number[]) {
    let params = ids.map(z => "ids=" + z).join("&");
    return this._http.get(this.deleteCuisinesUrl + '?' + params);
  }

  getVibeList() {
    return this._http.get(this.getVibesListUrl);
  }

  addVibe(title: any) {
    return this._http.postMultipart(this.saveNewVibeUrl, { title }, [], false);
  }

  deleteVibes(ids: number[]) {
    let params = ids.map(z => "ids=" + z).join("&");
    return this._http.get(this.deleteVibesUrl + '?' + params);
  }

  deleteSubAreas(ids: number[]) {
    let params = ids.map(z => "ids=" + z).join("&");
    return this._http.get(this.deleteSubAreasUrl + '?' + params);
  }

  getVenueGroupList(groupId: number) {
    return this._http.get(this.getGroupVenueListUrl + '?id=' + groupId);
  }

  update(model: VenueDetailsModel, files: File[]) {
    return this._http.postMultipart(this.updateVenue, model, files, true);
  }

  new(model: VenueDetailsModel, files: File[]) {
    return this._http.postMultipart(this.newVenue, model, files, true);
  }

  delete(id) {
    return this._http.get(this.deleteVenue + '?id=' + id, true);
  }

  getGroupContacts(groupId: number) {
    return this._http.get(this.getGroupContactsUrl + '?id=' + groupId);
  }

  getVenueOrder(type: any) {
    return this._http.get(this.getVenueOrders + '?type=' + type);
  }

  public getVenueAnalytisc(venueId: number) {
    return this._http.get(this.getVenueAnalytiscUrl + '?venueId=' + venueId);
  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/venues/venue-details/venue-details.service.ts